import { ElementRef, Pipe, PipeTransform, inject } from '@angular/core';

@Pipe({
  name: 'irdTruncatedTooltip',
})
export class IrdTruncatedTooltipPipe implements PipeTransform {
  private el = inject(ElementRef);

  transform(value: string): string {
    const tempElement = document.createElement('div');
    tempElement.style.position = 'absolute';
    tempElement.style.whiteSpace = 'nowrap';
    tempElement.style.visibility = 'hidden';
    tempElement.style.font = getComputedStyle(this.el.nativeElement).font;
    tempElement.textContent = value;

    document.body.appendChild(tempElement);
    const actualWidth = tempElement.scrollWidth;
    document.body.removeChild(tempElement);

    const isTruncated = actualWidth > this.el.nativeElement.clientWidth;
    return isTruncated ? value : '';
  }
}
